import { Ellipsis, TooltipTrigger } from "@visiblethread/react-components";
import clsx from "clsx";
import { array, number } from "prop-types";
import { useContext } from "react";

import ItemStepper from "../../../../../components/ItemStepper";
import { paragraphRowPropTypes } from "../../constants";
import CoverageTabContext from "../../CoverageTabContext";
import styles from "./AddressedInCell.module.scss";

const AddressedInCell = ({
  paragraphRowIndex,
  paragraphRow,
  value: addressedIn = [],
}) => {
  const { activeRowIndex, activeSection, onAddressedInStepUpdate } =
    useContext(CoverageTabContext);

  const { refs = [] } = paragraphRow;
  const isActiveParagraph = paragraphRowIndex === activeRowIndex;

  const isAddressedIn = addressedIn.length > 0;
  const currentAddressedIn = addressedIn.indexOf(activeSection?.title);

  const selectSection = (title) =>
    onAddressedInStepUpdate({ row: paragraphRow, title });

  const onUpdateStep = (e, newStep) => {
    e.stopPropagation();
    selectSection(addressedIn[newStep - 1]);
  };

  // Without stopping the click the row underneath handles it too, and the row always selects the
  // FIRST section addressing it — so any pill but the first selected the wrong section.
  const onClickPill = (title) => (event) => {
    event.preventDefault();
    event.stopPropagation();
    selectSection(title);
  };

  if (!isAddressedIn) {
    const refTitle = refs.length
      ? "Not addressed by any section"
      : "No requirement was extracted from this paragraph";

    return (
      <TooltipTrigger classes={styles.gapDash} content={refTitle} delay={500}>
        —
      </TooltipTrigger>
    );
  }

  return (
    <div className={styles.addressedIn}>
      {addressedIn.map((title) => {
        const isActiveTitle =
          isActiveParagraph && activeSection?.title === title;

        return (
          <button
            className={clsx(styles.sectionPill, isActiveTitle && styles.active)}
            key={title}
            type="button"
            title={title}
            onClick={onClickPill(title)}
          >
            <Ellipsis
              classes={styles.ellipsis}
              text={title}
              tooltipDelay={1000}
            />
          </button>
        );
      })}

      {isActiveParagraph && addressedIn.length > 1 && (
        <ItemStepper
          className={styles.stepper}
          current={currentAddressedIn + 1}
          nextLabel="Next Addressing Section"
          onUpdate={onUpdateStep}
          previousLabel="Previous Addressing Section"
          separator="/"
          total={addressedIn.length}
        />
      )}
    </div>
  );
};

AddressedInCell.propTypes = {
  paragraphRowIndex: number,
  paragraphRow: paragraphRowPropTypes,
  value: array,
};

export default AddressedInCell;
